import { formatSocialCount, formatReachCount } from '@/mocks/rfwSocial';

interface ViralStatsProps {
  shares: number;
  reach: number;
  interactions: number;
  trendPercent: number;
  trendDirection?: 'up' | 'down' | 'stable';
  compact?: boolean;
  className?: string;
}

export default function ViralStats({
  shares,
  reach,
  interactions,
  trendPercent,
  trendDirection = 'stable',
  compact = false,
  className = '',
}: ViralStatsProps) {
  const trendColor = trendDirection === 'up' ? 'text-emerald-600' : trendDirection === 'down' ? 'text-red-500' : 'text-foreground-400';
  const trendIcon = trendDirection === 'up' ? 'ri-arrow-up-line' : trendDirection === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line';
  const trendLabel = trendDirection === 'up' ? 'En ascenso' : trendDirection === 'down' ? 'Bajando' : 'Estable';

  if (compact) {
    return (
      <div className={`flex items-center gap-3 text-xs text-foreground-500 ${className}`}>
        <span className="flex items-center gap-1"><i className="ri-share-forward-line text-xs"></i> {formatSocialCount(shares)}</span>
        <span className="flex items-center gap-1"><i className="ri-eye-line text-xs"></i> {formatReachCount(reach)}</span>
        <span className={`flex items-center gap-1 font-semibold ${trendColor}`}>
          <i className={`${trendIcon} text-xs`}></i>
          {trendPercent > 0 ? '+' : ''}{trendPercent}%
        </span>
      </div>
    );
  }

  return (
    <div className={`flex flex-wrap items-center gap-4 md:gap-6 ${className}`}>
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-lg bg-sky-100 flex items-center justify-center">
          <i className="ri-share-forward-line text-sky-600 text-sm"></i>
        </div>
        <div>
          <p className="text-sm font-extrabold text-foreground-950 leading-none">{formatSocialCount(shares)}</p>
          <p className="text-[10px] font-medium text-foreground-400">Compartidos</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-lg bg-violet-100 flex items-center justify-center">
          <i className="ri-eye-line text-violet-600 text-sm"></i>
        </div>
        <div>
          <p className="text-sm font-extrabold text-foreground-950 leading-none">{formatReachCount(reach)}</p>
          <p className="text-[10px] font-medium text-foreground-400">Alcance</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-lg bg-amber-100 flex items-center justify-center">
          <i className="ri-flashlight-line text-amber-600 text-sm"></i>
        </div>
        <div>
          <p className="text-sm font-extrabold text-foreground-950 leading-none">{formatSocialCount(interactions)}</p>
          <p className="text-[10px] font-medium text-foreground-400">Interacciones</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${trendDirection === 'up' ? 'bg-emerald-100' : trendDirection === 'down' ? 'bg-red-100' : 'bg-foreground-100'}`}>
          <i className={`${trendIcon} ${trendColor} text-sm`}></i>
        </div>
        <div>
          <div className="flex items-center gap-1">
            <p className="text-sm font-extrabold text-foreground-950 leading-none">{trendPercent > 0 ? '+' : ''}{trendPercent}%</p>
          </div>
          <p className="text-[10px] font-medium text-foreground-400">{trendLabel}</p>
        </div>
      </div>
    </div>
  );
}